import { Flex } from '@atlaskit/primitives';
import type { FunctionComponent } from 'react';

import Headline from '../Rovo/Headline';
import SiteBypassBanner from '../shared/agent-consent/SiteBypassBanner/SiteBypassBanner';
import SiteSelector from './SiteSelector/SiteSelector';
import PermissionsBullets from '../Rovo/PermissionsBullets';
import Scopes from './Scopes/Scopes';

const Kaizen: FunctionComponent = () => {
  return (
    <Flex gap="space.400" direction="column" wrap="wrap" alignItems="start">
      <Flex alignItems="center" direction="column" gap="space.400">
        <Headline />
      </Flex>
      <SiteBypassBanner />
      <SiteSelector />
      <PermissionsBullets />
      <Scopes />
    </Flex>
  );
};

export default Kaizen;
